import { useAuth0 } from "@auth0/auth0-react";
import { Box, Button, Typography } from "@mui/material";
import { GatewayLogoIcon } from "../components/icons/gateway-logo";
import "./login.css";

export const Login = () => {
  const { loginWithRedirect } = useAuth0();

  return (
    <Box
      sx={{
        fontFamily: "satochi",
        height: "100vh",
        width: "100vw",
        backgroundColor: "#00193E",
        padding: "36px",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          height: "100%",
          width: "100%",
          backgroundColor: "#fff",
          color: "#000",
          borderRadius: "36px",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          overflowX: "hidden",
        }}
      >
        {/* Left Column */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "1.6rem",
            height: "100%",
            width: "100%",
            padding: "2rem",
          }}
        >
          <GatewayLogoIcon size={100} color="#00193E" />
          <Typography
            fontFamily="satochi"
            variant="h4"
            fontWeight="bold"
            color="#00193E"
          >
            Gateway Admin
          </Typography>

          <Typography fontFamily="satochi" fontSize="1.2rem" color="#00193E">
            Continue signing in with Auth0
          </Typography>

          <Button
            onClick={() => loginWithRedirect()}
            sx={{
              fontFamily: "satochi",
              backgroundColor: "#00193E",
              color: "#fff",
              borderRadius: "36px",
              padding: ".6rem 7rem",
              textTransform: "none",
              fontWeight: "bold",
              fontSize: "1rem",
              margin: "0",
              "&:hover": {
                backgroundColor: "#002a63",
              },
            }}
          >
            Sign in
          </Button>
        </Box>

        {/* Right Column */}
        <Box
          sx={{
            display: "flex",
            backgroundColor: "#F4F5F6",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            width: "100%",
          }}
        >
          <img
            src="/control_panel_undraw.svg"
            alt="Control Panel Illustration"
            style={{ maxWidth: "80%", maxHeight: "80%" }}
          />
        </Box>
      </Box>
    </Box>
  );
};
